/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../connect/v2/common/money';
import './common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "banking": {
        "nested": {
          "WithholdingConfig": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "accountId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "enabled": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "withholdingBps": {
                "type": "uint32",
                "id": 4,
                "rule": "optional"
              },
              "targetAmount": {
                "type": ".squareup.connect.v2.common.Money",
                "id": 5,
                "rule": "optional"
              },
              "completedAt": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "owner": {
                "type": ".squareup.banking.Owner",
                "id": 7,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banking?.nested?.WithholdingConfig) {
  $root.addJSON(jsonData);
}

/**
 * Represents a configuration for withholding money from the merchant's card
 * payments. The configuration currently operates across across all of the
 * merchant's locations. It is currently used for Savings product in US (powered by SFS).
 *
 * SOURCE WithholdingConfig @ squareup/banking/withholding_config_model.proto at 18:1
 */
export const WithholdingConfig = $root.lookupType('squareup.banking.WithholdingConfig');
fixType(WithholdingConfig, {
  accountId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(WithholdingConfig);